export const FEATURES_TYPES = {
  V21: 'V21',
  LEGACY: 'LEGACY',
};

export const FEATURE_KEYS = {
  EMAIL: 'email',
  EMAIL_PLUS: 'emailPlus',
  CORE: 'core',
  PLUS: 'plus',
  LITE: 'lite',
  STANDARD: 'standard',
  PREMIUM: 'premium',
};

export const PLAN_ID_TO_KEY = {
  // V10
  151: FEATURE_KEYS.EMAIL,
  152: FEATURE_KEYS.EMAIL_PLUS,
  // V10 - 2023 and 2024 price increase exclusions
  482: FEATURE_KEYS.EMAIL,
  483: FEATURE_KEYS.EMAIL_PLUS,
  // V10 - 2023 price increase
  230: FEATURE_KEYS.EMAIL,
  231: FEATURE_KEYS.EMAIL_PLUS,
  // V10 - 2024 price increase exclusions
  425: FEATURE_KEYS.EMAIL,
  426: FEATURE_KEYS.EMAIL_PLUS,
  // V10 - 2024 price increase tier 501 excludes
  320: FEATURE_KEYS.EMAIL,
  321: FEATURE_KEYS.EMAIL_PLUS,
  // V10 - tier 501 and 2024 price increase exclusion
  521: FEATURE_KEYS.EMAIL,
  522: FEATURE_KEYS.EMAIL_PLUS,

  // V11
  153: FEATURE_KEYS.EMAIL,
  154: FEATURE_KEYS.EMAIL_PLUS,
  // V11 - 2023 and 2024 price increase exclusions
  484: FEATURE_KEYS.EMAIL,
  485: FEATURE_KEYS.EMAIL_PLUS,
  // V11 - 2023 price increase
  232: FEATURE_KEYS.EMAIL,
  233: FEATURE_KEYS.EMAIL_PLUS,
  // V11 - 2024 price increase exclusions
  427: FEATURE_KEYS.EMAIL,
  428: FEATURE_KEYS.EMAIL_PLUS,
  // V11 - 2024 price increase tier 501 excludes
  322: FEATURE_KEYS.EMAIL,
  323: FEATURE_KEYS.EMAIL_PLUS,
  // V11 - tier 501 and 2024 price increase exclusion
  523: FEATURE_KEYS.EMAIL,
  524: FEATURE_KEYS.EMAIL_PLUS,

  // V19
  198: FEATURE_KEYS.CORE,
  199: FEATURE_KEYS.PLUS,
  // V19  - 2024 price increase exclusions
  462: FEATURE_KEYS.CORE,
  463: FEATURE_KEYS.PLUS,
  // V19 - 2023 and 2024 price increase exclusions
  500: FEATURE_KEYS.CORE,
  501: FEATURE_KEYS.PLUS,
  // V19 - 2023 price increase
  248: FEATURE_KEYS.CORE,
  249: FEATURE_KEYS.PLUS,
  // V19 - 2024 price increase tier 501 excludes
  347: FEATURE_KEYS.CORE,
  348: FEATURE_KEYS.PLUS,
  // V19 - tier 501 and 2024 price increase exclusion
  548: FEATURE_KEYS.CORE,
  549: FEATURE_KEYS.PLUS,

  // Standard V20
  201: FEATURE_KEYS.CORE,
  202: FEATURE_KEYS.PLUS,

  // V21
  214: FEATURE_KEYS.LITE,
  215: FEATURE_KEYS.STANDARD,
  216: FEATURE_KEYS.PREMIUM,

  // V23
  361: FEATURE_KEYS.LITE,
  362: FEATURE_KEYS.STANDARD,
  363: FEATURE_KEYS.PREMIUM,

  // Australia V1
  686: FEATURE_KEYS.LITE,
  687: FEATURE_KEYS.STANDARD,
  688: FEATURE_KEYS.PREMIUM,

  // New Zealand V1
  689: FEATURE_KEYS.LITE,
  690: FEATURE_KEYS.STANDARD,
  691: FEATURE_KEYS.PREMIUM,

  // Great Britain V1
  692: FEATURE_KEYS.LITE,
  693: FEATURE_KEYS.STANDARD,
  694: FEATURE_KEYS.PREMIUM,

  // Great Britain Lead Magnet
  697: FEATURE_KEYS.LITE,
  698: FEATURE_KEYS.STANDARD,
  699: FEATURE_KEYS.PREMIUM,

  // Blackbaud Partner
  725: FEATURE_KEYS.STANDARD,
  726: FEATURE_KEYS.PREMIUM,

  // Standard Large List 6/25 - V24
  727: FEATURE_KEYS.LITE,
  728: FEATURE_KEYS.STANDARD,
  729: FEATURE_KEYS.PREMIUM,

  // Standard 6/25 - V25
  730: FEATURE_KEYS.LITE,
  731: FEATURE_KEYS.STANDARD,
  732: FEATURE_KEYS.PREMIUM,

  // the rest of the plans from unknown plan groups
  700: FEATURE_KEYS.STANDARD,
  701: FEATURE_KEYS.PREMIUM,

  298: FEATURE_KEYS.LITE,
  299: FEATURE_KEYS.STANDARD,
  300: FEATURE_KEYS.PREMIUM,

  308: FEATURE_KEYS.STANDARD,
  309: FEATURE_KEYS.PREMIUM,

  351: FEATURE_KEYS.STANDARD,
  352: FEATURE_KEYS.PREMIUM,

  353: FEATURE_KEYS.LITE,
  354: FEATURE_KEYS.STANDARD,
  355: FEATURE_KEYS.PREMIUM,

  356: FEATURE_KEYS.LITE,
  357: FEATURE_KEYS.STANDARD,
};
